export const siteCofig = {
  siteName: "Tailwind Customizer",
  ownerName: "Shariar Hasan",
  copyRightYear: "2023",
};
